import styled from 'styled-components';

const StyledLabel = styled.label`
    &::before,
    &::after {
        top: 2px !important;
    }
`;

export { StyledLabel };
